module.exports = __webpack_public_path__ + "img/iphone4.b55ab30f.png";